module.exports = __webpack_public_path__ + "img/61_11.8a1fc02f.png";